<template>
  <div style="margin-top: 63px">
    <div class="hero">
      <div class="hero-ctn">
        <h1>
          {{ $t('testimonyTitle') }}
        </h1>
        <p>
          {{ $t('testimonyDescription') }}
        </p>
      </div>
    </div>
    <div style="background-color: #f5f6fa;" class="pb-10">
      <div class="container">
        <div class="card-2" v-for="(item, idx) in testimonies" :key="idx">
          <p class="text-center">{{ item.feedback }}</p>
          <div class="profile mt-5 d-flex" style="align-items: center">
            <div class="avatar">
              <img :src="$utils.loadImage(item.image_url)" alt="" width="60" height="60" class="avatar-image" />
            </div>
            <div class="testi-profile ml-5">
              <div class="name">{{ item.name }}</div>
              <div class="description">
                {{ item.job }} {{ item.place }}
              </div>
              <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="23" height="23"
                @click="redirectToLinkedIn(item.linkedin, item.name)" class="linkedin-image cursor-pointer" />
            </div>
          </div>
        </div>
        <div class="btn-stoke-blue" v-if="currentPage < total" @click="nextPrev" style="justify-content: center;">
          <span class="font-poppins">{{ $t('loadMore') }}</span>
        </div>
      </div>
    </div>
    <v-card elevation="0" class="call-center-container">
      <v-row style="padding: 20px 8px">
        <v-col cols="12">
          <div class="call-center-title">
            {{ $t('testimony1') }}
          </div>
          <div class="call-center-desc">
            {{ $t('testimony2') }}
          </div>
        </v-col>
        <v-col cols="12" class="call-center-button" @click="goToHome">
          <v-btn class="btn" elevation="0"> {{ $t('testimony3') }} </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MobileTestimony",
  data() {
    return {
      testimonies: [],
      currentPage: 1,
      total: 1,
    }
  },
  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      console.log(oldLocale, newLocale);
      console.clear();
      this.getTestimoni(true);
    },
  },
  methods: {
    async getTestimoni(clear) {
      try {
        const resp = await this.$http.get(`/v1/testimony?page=${this.currentPage}&per_page=20`);
        if (clear) {
          this.testimonies = [];
        }
        this.testimonies = this.testimonies.concat(resp.data.data.testimonies);
        if (resp.data.data.total) {
          this.total = parseInt(resp.data.data.total / 20) + 1;
        }
      } catch (err) {
        console.error(err);
      }
    },
    nextPrev() {
      this.currentPage++;
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Load More - Page ${this.currentPage} - Mobile Testimony Page`,
        value: 1,
      });
      this.getTestimoni();
    },
    redirectToLinkedIn(url, name) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Visit LinkedIn - ${name} - Mobile Testimony Page`,
        value: 1,
      });
      window.open(url, '_blank');
    },
    goToHome() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Home - Mobile Testimony Page',
        value: 1,
      });
      this.$router.push('/');
    },
  },
  mounted() {
    this.testimonies = [];
    this.getTestimoni();
    this.$gtag.pageview(this.$route);
  }
}
</script>

<style scoped src="./testimony.css"></style>